export const API = process.env.REACT_APP_API_ENDPOINT ||  "https://api.cntlandmanager.com/api"
